import { render } from "./EmpPayroll.vue?vue&type=template&id=5f35ad2a&scoped=true"
const script = {}

import "./EmpPayroll.vue?vue&type=style&index=0&id=5f35ad2a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f35ad2a"]])

export default __exports__